import { useQuery } from 'react-apollo';
import { GET_ALL_CATALOGS } from './queries';
import { getAllCatalogs } from './types/getAllCatalogs';

export const useCatalogs = () => {
  const { data, loading, error } = useQuery<getAllCatalogs>(GET_ALL_CATALOGS);

  return { catalogs: data?.catalogs ?? [], loading, error };
};
